const agreementParts = {
	USER: "user",
	NARRATOR: "narrator",
	PUBLISHER: "publisher",
	SUBCONTRACTOR: "subcontractor",
};

export default agreementParts;
